import PropTypes from 'prop-types';
import CycleCreateContent from './CycleCreateContent';
import CycleCreateHeader from './CycleCreateHeader';
import CycleCreateWarnings from './CycleCreateWarnings';

function CycleCreate(props) {
    const { header, content, controls, warnings, getValidationData } = props.configuration;
    const modelSelector = props.modelSelector || (state => state[props.modelProperty].model);

    return (
        <div>
            <section className="page_static">
                <CycleCreateHeader header={header} modelSelector={modelSelector} />
                <CycleCreateWarnings warnings={warnings} modelSelector={modelSelector} />
            </section>
            <CycleCreateContent
                content={content}
                controls={controls}
                modelSelector={modelSelector}
                getValidationData={getValidationData}
            />
        </div>
    );
}

CycleCreate.propTypes = {
    configuration: PropTypes.object,
    header: PropTypes.object,
    controls: PropTypes.object,
};

export default CycleCreate;
